import axios from 'axios';

const dev = process.env.NODE_ENV !== 'production';
const prod = !dev;
export const publicUrl = prod
  ? 'https://merchant.goyomart.mn/'
  : 'http://localhost:8081/';
export const baseUrl = prod
  ? 'https://merchant.goyomart.mn/merchant'
  : 'http://localhost:8081/merchant';

const instance = axios.create({
  baseURL: baseUrl,
});

export default instance;
